import {Component, inject} from '@angular/core';
import {LayoutService} from '@/core/services/layout/layout.service';

@Component({
    selector: '[app-right-menu]',
    templateUrl: './rightmenu.component.html',
    styleUrls: ['./rightmenu.component.scss'],
    standalone: false,
})
export class RightMenuComponent {
    layoutService = inject(LayoutService);

    get rightMenuActive(): boolean {
        return this.layoutService.layoutState().rightMenuActive;
    }

    set rightMenuActive(_val: boolean) {
        this.layoutService.layoutState.update((prev) => ({ ...prev, rightMenuActive: _val }));
    }
}
